import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor, replaceAll } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPPlanetSignificatorCuspalView ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Planet Significators - Cuspal View');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/planetsignificatorcuspalview/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

  const tdwidth = {
    width: "15%",
  };
    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
            <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Planet Significators - Cuspal View</h5></caption>
          <thead>
            <tr class="p-0 m-0">
              <th class="m-0 p-1 kptable-td">House</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>A</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>B</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>C</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>D</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>E</th> 
            </tr>
          </thead>
          <tbody>
            { chartData.map((planet) => (
                <tr class="p-0 m-0"  onClick={handleClickColor}>
                    <th class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{replaceAll(planet[1],",",", ")}</td>
                    <td class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{replaceAll(planet[2],",",", ")}</td>
                    <td class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{replaceAll(planet[3],",",", ")}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{replaceAll(planet[4],",",", ")}</td>
                    <td class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{replaceAll(planet[5],",",", ")}</td>
                </tr>
            ))}
            </tbody>  
          </table>
          <span class="m-0 p-0 kpfont">
          A - Planet's Star Lord in Cuspal<br/>
          B - Planets in Cuspal<br/>
          C - Planet's Star Lord in Cuspal as Sign Lord<br/>
          D - Planets in Cuspal as Sign Lord<br/>
          E - Planets in Cuspal as Sub Lord<br/>
          </span>
        </>
           )
          }
        </>    
        );
  }